import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import React from "react";
import LazyLoad from "react-lazyload";
import {
  getPricePerKilo,
  getPricePerProductgroup,
} from "../../utils/weightUtils";
import ProductAmountCounter from "../products/ProductAmountCounter";
import "./Catalogus.scss";

function BusinessCatalogus(props) {
  return (
    <Grid container justifyContent="center" alignItems="flex-start" spacing={3}>
      {props.data.map((rowData) => (
        <LazyLoad placeholder="Loading">
          <Grid item xs={12}>
            <div className="photoDivZakelijk">
              {rowData.image ? (
                <img className="photo" src={rowData.image}></img>
              ) : null}
              <ListItem alignItems="flex-start">
                <ListItemText
                  primary={rowData.name}
                  sx={{ color: "blue" }}
                  secondary={
                    <React.Fragment>
                      <Typography
                        component="span"
                        variant="body2"
                        className="inline"
                        color="textPrimary"
                      >
                        {getPricePerProductgroup(rowData)}
                      </Typography>
                      {getPricePerKilo(rowData)}
                    </React.Fragment>
                  }
                />
                <div>
                  {props.loginSuccesful ? (
                    <ProductAmountCounter
                      productId={rowData.id}
                      screenType="Assortiment"
                    />
                  ) : null}
                </div>
              </ListItem>
              <Divider variant="inset" style={{ marginBottom: 0 }} />
            </div>
          </Grid>
        </LazyLoad>
      ))}
    </Grid>
  );
}

export default BusinessCatalogus;
